import { Component } from '@angular/core'

@Component({
  selector: 'kdgh-home-route',
  templateUrl: './home-route.component.html',
  styleUrls: ['./home-route.component.scss'],
})
export class HomeRouteComponent {}
